module.exports = __webpack_public_path__ + "img/file-icon-pdf.7ec69514.svg";